var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgUpdateGoverningDocuments = function SvgUpdateGoverningDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.286.84H79.05C82.344.84 85 3.48 85 6.756v48.49c0 3.275-2.656 5.916-5.95 5.916H5.95c-3.294 0-5.95-2.64-5.95-5.916V18.84c0-3.275 2.656-5.916 5.95-5.916h29.386V6.756c0-3.275 2.656-5.916 5.95-5.916zm1.116 21.021l-10.543 9h21.086l-10.543-9zm4.994 9h-9.988v12.316h9.988V30.86zM27.42 48.726a2.22 2.22 0 012.22-2.22h26.636a2.22 2.22 0 010 4.44H29.639a2.22 2.22 0 01-2.22-2.22z",
    fill: "#33BB40"
  })));
};

export default SvgUpdateGoverningDocuments;